import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-twenty-one',
  templateUrl: './home-twenty-one.component.html',
  styleUrls: ['./home-twenty-one.component.scss']
})
export class HomeTwentyOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
